import React from "react";
import styles from "./style.module.css";
import { images } from "../../assets/images";
import { Link } from "react-router-dom";
const Footer = () => {
  const { Youtube, X, LinkedIn, Instagram, Facebook, Chat } = images;
  return (
    <footer className={styles.footer}>
      <div className={styles.footerTop}>
        <div className={styles.footerColumn1}>
          {/* <div className={styles.content}></div> */}
          <div className={styles.logoContainer}>
            <img src={images.logo} alt="Logo" className={styles.img} />
            <p>
              At avasify, connections thrive, dreams are nurtured, and
              possibilities manifest into reality.
            </p>
          </div>
          <div>
            <h5>Find us online</h5>
            <div className={styles.socialIcons}>
              <img src={Instagram} alt="Instagram" />
              <img src={Youtube} alt="Youtube" />
              <img src={X} alt="X" />

              <img src={LinkedIn} alt="LinkedIn" />
              <img src={Facebook} alt="Facebook" className={styles.icon} />
            </div>
          </div>
        </div>
        <div className={styles.footerColumn2}>
          <div className={styles.links}>
            <li>Terms and conditions</li>
            <li>Privacy Policy</li>
            <li>
              <Link to="/career" reloadDocument>
                Careers
              </Link>
            </li>
            <li>
              {" "}
              <Link to="/corporate" reloadDocument>
                Corporate Information
              </Link>{" "}
            </li>
            <li>Support</li>
          </div>
        </div>
        <div className={styles.footerColumn3}>
          <div className={styles.innerdiv}>
            <h3>Akshay Thakur</h3>
            <p>
              Vellore Institute of Technology, Kelambakkam - Vandalur Rd, Rajan Nagar, Chennai, Tamil Nadu 600127
            </p>
            <p>+919422319541</p>
            <p>akshay3thakur@proton.me</p>
          </div>
        </div>
      </div>
      <div className={styles.footerBottom}>
        <p>&copy; 2024 Avasify All Rights Reserved</p>
        <div className={styles.ChatIcon}>
          <img src={Chat} alt="chat" />
        </div>
      </div>
    </footer>
  );
};

export default Footer;
